import { type Dish } from "@fitness-app/data-models/entities/Dish";
import { DishIssueStatus } from "@fitness-app/data-models/entities/DishIssue";
import { generateUniqId } from "@fitness-app/utils/src/helpers/generateUniqId";

import { useUserRole } from "~/hooks/trainer/useUserRole";
import { analyticsService } from "~/store/initializeStore";
import { useReportDishIssue } from "../MealsPlans/MealsPlanDetails/tabs/MealsPlanSchedule/hooks/useReportDishIssue";
import { useUpdateDishIssue } from "./useUpdateDishIssue";

export const useUpdateDishInTemplate = (context?: string) => {
  const { userId } = useUserRole();

  const { reportIssue, isReporting } = useReportDishIssue(false);
  const { updateIssue, isUpdating } = useUpdateDishIssue(true, "Potrawa zostanie zaktualizowana w innych szablonach");

  const updateDishInTemplate = async (dishId: string, beforeUpdate: Dish) => {
    const issueId = generateUniqId();

    await reportIssue({
      dishId,
      reason: "",
      ownerId: userId,
      id: issueId,
    });

    await updateIssue({
      id: issueId,
      status: DishIssueStatus.Resolved,
      metadata: {
        updateTemplates: true,
        context: context || "lack_of_context",
        beforeUpdate,
      },
    });

    analyticsService.track("update_dish_in_templates", {
      dishId,
      context: context || "lack_of_context",
    });
  };

  return {
    updateDishInTemplate,
    isUpdatingDishInTemplate: isReporting || isUpdating,
  };
};
